/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Formulas_LinkInputs */

const en_gc_story_formulas_link = /** @type {(inputs: Gc_Story_Formulas_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice SUM and IF`)
};

const zh_gc_story_formulas_link = /** @type {(inputs: Gc_Story_Formulas_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习 SUM 与 IF`)
};

/**
* | output |
* | --- |
* | "Practice SUM and IF" |
*
* @param {Gc_Story_Formulas_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_formulas_link = /** @type {((inputs?: Gc_Story_Formulas_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Formulas_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_formulas_link(inputs)
	return zh_gc_story_formulas_link(inputs)
});
export { gc_story_formulas_link as "gc.story.formulas.link" }